import { createAction } from 'redux-actions'
import api from '@vmockinc/dashboard/services/api'
import { notification, generateUrl } from '../services/helpers'
import { push } from 'react-router-redux'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'

const PREFIX = 'AspireFeedback.'
const timeOutMilliseconds = 2000

export const FETCH_FEEDBACK_INIT = PREFIX + 'FETCH_FEEDBACK_INIT'
export const FETCH_FEEDBACK_DONE = PREFIX + 'FETCH_FEEDBACK_DONE'
export const FETCH_FEEDBACK_FAIL = PREFIX + 'FETCH_FEEDBACK_FAIL'
export const FETCH_FEEDBACK_DATA = PREFIX + 'FETCH_FEEDBACK_DATA'
export const PDF_LANGUAGE_CHANGE = PREFIX + 'PDF_LANGUAGE_CHANGE'
export const UPDATE_FEEDBACK_STATE = PREFIX + 'UPDATE_FEEDBACK_STATE'
const fetchFeedbackInit = createAction(FETCH_FEEDBACK_INIT)
const fetchFeedbackDone = createAction(FETCH_FEEDBACK_DONE)
const fetchFeedbackFail = createAction(FETCH_FEEDBACK_FAIL)
const fetchFeedbackData = createAction(FETCH_FEEDBACK_DATA)
const pdfLanguageChange = createAction(PDF_LANGUAGE_CHANGE)
export const updateFeedbackState = createAction(UPDATE_FEEDBACK_STATE)

const scoreClassDefaults = {
  bullet_length_score_class: () => ({
    bullet_length_score: 0,
    bullet_length_color_feedback: null,
  }),
  bullets_count_score_class: () => ({
    bullets_count_score: 0,
    bullets_count_color_feedback: null,
  }),
  buzzwords_score_class: (i) => ({
    buzzwords: [],
    buzzwords_color_feedback: null,
    buzzwords_count: 0,
    buzzwords_score: 0,
    sub_section_mapping: i,
  }),
  grammar_score_class: (i) => ({
    grammar: [],
    grammar_color_feedback: null,
    grammar_count: 0,
    grammar_score: 0,
    sub_section_mapping: i,
  }),
  tense_score_class: (i) => ({
    tense_inconsistency: [],
    tense_inconsistency_count: 0,
    tense_score: 0,
    tense_color_feedback: null,
    sub_section_mapping: i,
  }),
  verb_overusage_score_class: (i) => ({
    verb_overusage_score: 0,
    verb_overusage_color_feedback: null,
    verb_overusage: [],
    verb_overusage_count: 0,
    sub_section_mapping: i,
  }),
  overall_presentation_score_class: (i) => ({
    sample_score: 0,
    color_feedback: null,
    sub_section_mapping: i,
  }),
  overall_language_score_class: (i) => ({
    sample_score: 0,
    color_feedback: null,
    sub_section_mapping: i,
  })
}

function fillMissingScoreClasses(response, textArray) {
  const keys = Object.keys(scoreClassDefaults)
  keys.forEach((key) => {
    if (response[key]) {
      if (
        (key === 'overall_presentation_score_class' || key === 'overall_language_score_class') &&
        response[key].sub_section
      ) {
        const subSection = response[key].sub_section
        for (let i = 0; i < textArray.length; i++) {
          if (
            (Array.isArray(subSection) && !subSection[i]) ||
            (!Array.isArray(subSection) && !subSection.hasOwnProperty(i))
          ) {
            response[key].sub_section[i] = scoreClassDefaults[key](i)
          }
        }
      }
      else if (Array.isArray(response[key])) {
        for (let i = 0; i < textArray.length; i++) {
          if (!response[key][i]) {
            response[key][i] =
              key !== 'bullet_length_score_class' &&
              key !== 'bullets_count_score_class'
                ? scoreClassDefaults[key](i)
                : scoreClassDefaults[key]()
          }
        }
      }
      else if (
        typeof response[key] === 'object' &&
        response[key] !== null
      ) {
        for (let i = 0; i < textArray.length; i++) {
          if (!response[key].hasOwnProperty(i)) {
            response[key][i] =
              key !== 'bullet_length_score_class' &&
              key !== 'bullets_count_score_class'
                ? scoreClassDefaults[key](i)
                : scoreClassDefaults[key]()
          }
        }
      }
    }
  })
}

export function fetchFeedback(fetchId, fetchStatic = true) {
  return (dispatch, getState) => {
    dispatch(fetchFeedbackInit())
    return api
      .service('ap')
      .get(`aspire/result`, {
        modules: '["ui"]',
        id: fetchId,
      })
      .done((response) => {
        if (response.status === 'processing') {
          dispatch(fetchFeedbackDone(response))
        } else if (
          getState().aspireFeedbackData.fetched === false &&
          getState().aspireFeedbackData.fetching === true
        ) {
          const isAspireGenAiEnabled = getState().userCustomizations.data.is_aspire_gen_ai_enabled
          const dashboardLanguage = getState().dashboardHome.languagePreference
          if(response?.ui?.is_gen_ai_feedback) {
            fillMissingScoreClasses(response?.ui?.section_wise_feedback?.education_feedback,
              response?.ui?.section_wise_feedback?.education_feedback?.text_array)
            fillMissingScoreClasses(response?.ui?.section_wise_feedback?.experience_feedback,
              response?.ui?.section_wise_feedback?.experience_feedback?.text_array)
          }
          dispatch(fetchFeedbackDone(response))
          if (isAspireGenAiEnabled === false) {
            dispatch(pdfLanguageChange(dashboardLanguage))
          } else if ( isAspireGenAiEnabled && response.hasOwnProperty('pdf_language') ) {
            dispatch(pdfLanguageChange(response.pdf_language))
          }
          response['fetch_static'] = fetchStatic
          dispatch(fetchFeedbackData(response))
        }
      })
      .fail((xhr) => {
        dispatch(fetchFeedbackFail(xhr.responseJSON))
      })
  }
}

export const FETCHED_STATIC_DATA = PREFIX + 'FETCHED_STATIC_DATA'
const fetchedStaticData = createAction(FETCHED_STATIC_DATA)

export function detailedFeedbackUpdated() {
  return (dispatch) => {
    dispatch(fetchedStaticData())
  }
}

export function redirectSelect(fetchId = -1, page = 'summary', section = '') {
  const path = generateUrl(fetchId, page, section)
  return (dispatch) => {
    dispatch(push(path))
  }
}

export function runNotifier(message) {
  notification(message, 'information', timeOutMilliseconds)
}

export const SET_RESUME_OR_CV = PREFIX + 'SET_RESUME_OR_CV'
const setResumeOrCv = createAction(SET_RESUME_OR_CV)

export function resumeOrCv(value) {
  return (dispatch) => {
    dispatch(setResumeOrCv(value))
  }
}

export const MARK_SECTION_VISITED = PREFIX + 'MARK_SECTION_VISITED'
const markSectionVisitedDone = createAction(MARK_SECTION_VISITED)

export function markSectionVisited($module) {
  return (dispatch) => {
    return api
      .service('ap')
      .post('aspire/section-visit', { module: $module })
      .done((response) => dispatch(markSectionVisitedDone($module)))
      .fail(function (xhr) {
        sendTrackingData(
          'process',
          'aspire_actions',
          'error',
          'mark_section_visited_api_failed-' + JSON.parse(xhr.responseText)
        )
      })
  }
}
